export const zcuList = [{
  left: '概述：Zabbix功能点',
  right: '数据可视化：聚合图形和幻灯片展示'
}, {
  left: 'Zabbix基本概念',
  right: '数据可视化：仪表板和小部件概述'
}, {
  left: 'Zabbix用户界面概述',
  right: '数据可视化：资产管理'
}, {
  left: '用户管理',
  right: '数据可视化：服务'
}, {
  left: '数据可视化：最新数据',
  right: '数据可视化：报表'
}, {
  left: '数据可视化：图形',
  right: '告警：概述'
}, {
  left: '数据可视化：数据总览',
  right: '告警：升级'
}, {
  left: '数据可视化：Web监控',
  right: '告警：主动监控'
}, {
  left: '数据可视化：异常',
  right: '告警：维护'
}, {
  left: '问题：确认',
  right: '认证考试'
}, {
  left: '数据可视化：Maps',
  right: ''
}]

export const zcsList = [
  [{
    left: 'Zabbix功能点概述',
    right: '管理：创建新用户'
  }, {
    left: 'Zabbix产品开发核心原则介绍',
    right: '管理：实践操作'
  }, {
    left: '产品相关重要决策',
    right: '管理：培训师演示'
  }, {
    left: '架构：Zabbix组件图解',
    right: '定义：Zabbix 术语介绍'
  }, {
    left: '准备：网络时间协议',
    right: '监控：主机'
  }, {
    left: '准备：时区',
    right: '监控：概述'
  }, {
    left: '准备：SWAP文件设置',
    right: '监控：最新数据'
  }, {
    left: '准备：防火墙',
    right: '监控：最新数据-简单图表'
  }, {
    left: '准备：Selinux',
    right: '监控：最新数据-多元素图表'
  }, {
    left: '设置：Server、DB、GUI：获取Zabbix',
    right: '监控：最新数据-应用程序'
  }, {
    left: '设置：Server、DB、GUI：Server要求',
    right: '配置：主机组'
  }, {
    left: '设置：Server、DB、GUI：用设置包设置Zabbix',
    right: '配置：主机'
  }, {
    left: '设置：Server、DB、GUI：前端要求',
    right: '配置：实践操作'
  }, {
    left: '设置：Server、DB、GUI：实践 设置',
    right: '配置：培训师演示'
  }, {
    left: '设置：Server、DB、GUI：培训师演示',
    right: '配置：监控项新建/修改'
  }, {
    left: 'Zabbix interface：预处理',
    right: '配置：测试新的/现有的被动监控项'
  }, {
    left: 'Zabbix interface：interface概述',
    right: '数据收集：监控项筛选/批量编辑并立即检查/清除历史记录'
  }, {
    left: 'Zabbix interface：权限设置',
    right: '数据收集：预处理'
  }, {
    left: '用户配置文件：设置、主题、媒体和消息',
    right: '数据收集：Agent-less监控'
  }, {
    left: '用户配置文件：培训师演示',
    right: '数据收集：简单检查'
  }, {
    left: '用户配置文件：用户资料',
    right: '数据收集：ICMP检查'
  }, {
    left: '用户配置文件：主题颜色',
    right: '数据收集：实践操作'
  }, {
    left: '用户配置文件：用户 媒介',
    right: '数据收集：培训师演示'
  }, {
    left: '用户配置文件：消息',
    right: ''
  }], [{
    left: 'Agent安装：简介',
    right: '问题检测：提示和技巧'
  }, {
    left: 'Agent安装：安装包设置Linux Agent',
    right: '问题检测：宏'
  }, {
    left: 'Agent安装：安装在Windows上Agent，MACOS',
    right: '问题检测：其他触发器示例'
  }, {
    left: 'Agent安装：Zabbix Agent 2',
    right: '问题检测：高级问题检测'
  }, {
    left: 'Agent安装：实践 操作环节',
    right: '问题检测：实践操作环节'
  }, {
    left: 'Agent安装：培训师演示',
    right: '问题检测：培训师演示'
  }, {
    left: '数据收集：Zabbix Agent被动检查',
    right: '配置：使用模板'
  }, {
    left: '命令行实用程序：zabbix_server、zabbix_get、zabbix_agent',
    right: '配置：培训师演示'
  }, {
    left: '命令行实用程序： 实践操作环节',
    right: '配置：标签-模板和主机'
  }, {
    left: '命令行实用程序：培训师演示',
    right: '配置：实践操作环节'
  }, {
    left: '数据收集：Zabbix Agent 主动检查',
    right: '配置：培训师演示'
  }, {
    left: '数据收集： 实践操作环节',
    right: '数据收集：Agent用户参数'
  }, {
    left: '数据收集：培训师演示',
    right: '数据收集：实践操作环节'
  }, {
    left: '数据收集：Q&A',
    right: '数据收集：培训师演示'
  }, {
    left: '数据收集：监控 Windows',
    right: '命令行实用程序：zabbix_sender'
  }, {
    left: '数据收集：培训师演示',
    right: '命令行实用程序：实践操作环节'
  }, {
    left: '问题检测：触发器、低敏感的触发器、依赖项',
    right: '命令行实用程序：培训师演示'
  }, {
    left: '问题检测：触发事件标记',
    right: '数据收集：SSH/Telnet检查'
  }, {
    left: '问题检测：内置 用户宏功能',
    right: '数据收集：实践操作环节'
  }], [{
    left: '数据采集：HTTP检查',
    right: '数据采集：培训师演示'
  }, {
    left: '数据采集：实践操作',
    right: '数据采集：SNMP监控'
  }, {
    left: '数据采集：培训师演示',
    right: '数据采集：SNMP traps'
  }, {
    left: '数据采集：依赖监控项',
    right: '数据采集：实践操作'
  }, {
    left: '数据采集：实践操作',
    right: '数据采集：培训师演示'
  }, {
    left: '数据采集：培训师演示',
    right: '数据采集：日志文件监控'
  }, {
    left: '数据采集：Calculated checks',
    right: '数据采集：实践操作'
  }, {
    left: '数据采集：实践操作',
    right: '数据采集：培训师演示'
  }, {
    left: '数据采集：培训师演示',
    right: '数据采集：Web检查'
  }, {
    left: '数据采集： 聚合检查',
    right: '数据采集：实践操作'
  }, {
    left: '数据采集：实践操作',
    right: '数据采集：培训师演示'
  }], [{
    left: '资产：自动采集',
    right: '数据可视化：实践操作'
  }, {
    left: '资产：实践操作',
    right: '自动化：LLD概述'
  }, {
    left: '资产：培训师演示',
    right: '分布式监控：Proxies'
  }, {
    left: '数据可视化：自定义图形',
    right: '自动化：网络发现、自动注册、集成'
  }, {
    left: '数据可视化：实践操作',
    right: '管理：配置文件'
  }, {
    left: '数据可视化：培训师演示',
    right: '管理：XML导入/导出'
  }, {
    left: '数据可视化：拓扑图Maps',
    right: '管理：实践操作'
  }, {
    left: '数据可视化：培训师演示',
    right: '管理：Section概述'
  }, {
    left: '数据可视化：实践操作',
    right: '管理：管理用户和用户组权限，审计'
  }, {
    left: '数据可视化： Screens',
    right: '管理：实践操作'
  }, {
    left: '数据可视化：培训师演示',
    right: '管理：工作时间、 housekeeper、认证'
  }, {
    left: '数据可视化：实践操作',
    right: '管理：前端脚本'
  }, {
    left: '数据可视化：仪表板',
    right: '管理：实践操作'
  }, {
    left: '数据可视化：培训师演示',
    right: '管理：培训师演示'
  }, {
    left: '数据可视化：实践操作',
    right: '管理：前端模块'
  }, {
    left: '数据可视化：Slideshows',
    right: '管理：Zabbix server运行状况'
  }, {
    left: '数据可视化：培训师演示',
    right: '管理：培训师演示'
  }], [{
    left: 'Inventory:自动采集',
    right: '数据可视化: Screens'
  }, {
    left: 'Inventory:实践操作环节',
    right: '数据可视化: 培训师演示'
  }, {
    left: 'Inventory:培训师演示',
    right: '数据可视化: 实践操作环节'
  }, {
    left: '数据可视化: 自定义图表',
    right: '数据可视化: 仪表板'
  }, {
    left: '数据可视化: 实践操作环节',
    right: '数据可视化: 培训师演示'
  }, {
    left: '数据可视化: 培训师演示',
    right: '数据可视化: 实践操作环节'
  }, {
    left: '数据可视化: Maps',
    right: '数据可视化: Slideshows'
  }, {
    left: '数据可视化: 培训师演示',
    right: '数据可视化: 培训师演示'
  }, {
    left: '数据可视化: 实践操作环节',
    right: '数据可视化: 实践操作环节'
  }]
]

export const zcpList = [
  [{
    left: '数据收集：数据库监控',
    right: '配置：趋势预测，百分位数'
  }, {
    left: '自动化：LLD-自动发现主机资源，windows服务，使用 SNMP和SQL实现自动发现',
    right: '配置：批量指标和关联监控'
  }, {
    left: '数据收集：VMware监控',
    right: '配置：监控项值预处理'
  }, {
    left: '数据收集：Java监控',
    right: '用户权限：创建用户、用户组和设置'
  }], [
    {
      left: '自动化：网络发现',
      right: '安装：Docker镜像'
    }, {
      left: '自动化：自动注册',
      right: '管理：扩展和性能调优-如何监控百万级指标和触发器'
    }, {
      left: '配置参数：Zabbix server，Zabbix agent',
      right: '管理：运维-实践，数据库容量规划，升级'
    }, {
      left: '安装：分布式监控-主动/被动 proxies',
      right: '管理：问题，挑战和解决方案-与第三方系统集成、性能和维护问题'
    }, {
      left: '安装：Zabbix中的加密',
      right: ''
    }], [{
    left: '课程内容补充中',
    right: ''
  }]
]

export const zceList = [
  [{
    left: '安装：从源代码安装Zabbix',
    right: '数据收集：使用外部检查和可加载模块扩展Zabbix'
  }, {
    left: '管理：为Zabbix创建SELinux规则',
    right: '配置：基于触发器的事件关联'
  }, {
    left: '管理：使用SSL保护Zabbix前端',
    right: '配置：全局事件关联'
  }, {
    left: '数据收集：设置SNMP traps',
    right: '管理：AD和HTTP身份验证'
  }, {
    left: '数据收集：IPMI',
    right: ''
  }], [{
    left: 'Zabbix API：概述',
    right: '管理：高性能存储引擎（Elasticsearch）'
  }, {
    left: 'Zabbix API：获取数据',
    right: '管理：实时数据导出'
  }, {
    left: '管理：Zabbix数据库架构概述',
    right: '数据收集：HTTP检查'
  }, {
    left: '管理：MySQL表分区',
    right: '管理：高性能HTTP Server（NGINX）'
  }], [{
    left: '数据收集：LLD-SNMP对象',
    right: '管理：Zabbix服务进程'
  }, {
    left: '数据收集：LLD-JMX对象',
    right: '安装：高可用和冗余'
  }, {
    left: '数据收集：自定义LLD规则',
    right: ''
  }], [{
    left: '课程内容更新中',
    right: ''
  }], [{
    left: '课程内容更新中',
    right: ''
  }]
]
